import React from "react";
import { ReactComponent as Spinner } from "assets/icons/spinner.svg";
import { classNames } from "helpers/ClassNameHelper";

interface Props {
    className?: string;
    size?: "small" | "medium" | "large";
}
export const Loading: React.FC<Props> = ({ className, size = "medium" }) => (
    <div className={classNames("loading-container", className)}>
        <Spinner className={classNames(`spinner spinner--${size}`)} />
    </div>
);
